import type { TaskItem } from '@nexus/core';
import { MenuListItem, StatusBadge } from '@nexus/ui';
import { useTranslation } from 'react-i18next';
import { formatDate, localIsoDate } from '../i18n/format';
import { dueDate } from '../reminders/api';
import { useReminderOwner } from '../reminders/reminder-entry';

/** One open task as a link to its record, with title, record, due day and overdue mark. */
export function TaskEntry({ item }: { item: TaskItem }) {
  const { t, i18n } = useTranslation();
  const owner = useReminderOwner()(item.entity);
  const overdue = item.dueOn !== null && item.dueOn < localIsoDate(new Date());
  return (
    <MenuListItem
      icon={owner.icon}
      href={item.path}
      wrapDescription
      description={
        <>
          {owner.name && `${t(owner.name)} · `}
          {item.recordTitle ?? t('tasks.untitled')}
          {item.dueOn && (
            <>
              {' · '}
              <time dateTime={item.dueOn}>
                {t('tasks.due', { day: formatDate(dueDate(item.dueOn), i18n.language) })}
              </time>
            </>
          )}
        </>
      }
      trailing={overdue && <StatusBadge status="danger">{t('tasks.overdue')}</StatusBadge>}
    >
      {item.title}
    </MenuListItem>
  );
}
